import { apiFetch } from "@/client/lib/api";
import type { MfaChallengeResponse, RecoveryCodesResponse } from "@/client/features/auth/auth-api";

/** Typed client for self-service account endpoints (the customer Settings page). */

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const meApi = {
  changePassword: (input: ChangePasswordInput) =>
    apiFetch<void>("/me/password", { method: "POST", json: input }),
  deleteAccount: (password: string) =>
    apiFetch<void>("/me", { method: "DELETE", json: { password } }),
  replaceMfa: (password: string) =>
    apiFetch<MfaChallengeResponse>("/me/mfa/replace", {
      method: "POST",
      json: { password },
    }),
  regenerateRecoveryCodes: (password: string) =>
    apiFetch<RecoveryCodesResponse>("/me/mfa/recovery-codes", {
      method: "POST",
      json: { password },
    }),
};
